import React, { useState } from "react";
import { Box, CircularProgress, Typography, Fade } from "@mui/material";
import { Send } from "@mui/icons-material";
import "../../styles/components/ContactForm.css";

function ContactForm() {
  const [loading, setLoading] = useState(true);

  const iframeStyle = {
    width: "100%",
    border: "none",
    height: "600px",
    display: loading ? "none" : "block",
  };

  const handleLoad = () => {
    setLoading(false);
  };

  return (
    <Fade in timeout={1400}>
      <Box>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: 600,
            mb: 4,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Send sx={{ color: "#0066CC" }} />
          Message
        </Typography>

        <Typography
          variant="body1"
          sx={{ mb: 4, color: "#666", lineHeight: 1.6 }}
        >
          Fill out the form below and I'll get back to you as soon as possible.
          I typically respond within 24 hours during business days.
        </Typography>

        <div className="contact-form-container">
          {loading && (
            <div className="loading-container">
              <CircularProgress size={60} sx={{ color: "#0066CC", mb: 2 }} />
              <Typography variant="h6" color="text.secondary">
                Loading Contact Form...
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Please wait while we prepare the form for you
              </Typography>
            </div>
          )}

          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLScc2ln5n13BB2I-wijN2-lDLurhHTKyElIuBeExxWjV2r3Y4Q/viewform?embedded=true"
            style={iframeStyle}
            onLoad={handleLoad}
            title="Contact Form"
          />
        </div>
      </Box>
    </Fade>
  );
}

export default ContactForm;
